import { Injectable } from '@angular/core';
import { IVATRate } from '../interfaces/vatrate';
import { IVATRateFilter } from '../interfaces/vatrate-filter';
import { EditService } from './edit.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class VATRateService extends EditService<IVATRate, IVATRateFilter> {
  url = '/api/vatrates';
  entityTitle = 'The VAT rate ';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  save(data: any, isNew: boolean): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    let successMsg = isNew ? 'The VAT rate added.' : 'The VAT rate updated.';

    return this.handleRequest(
      this.http.post(this.url + '/save', data, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
}
